import React from 'react';
import { ForYouContainer } from './styled';

function HereForYouSection(props) {
  const data = [
    {
      image:
        'https://images.myloapp.in/NestJsUploads/1727426586340-Effective.svg',
      html: '<p>Made with <span class=subText><b> Effective </b> </span> <br/> Ingredients</p>',
    },
    {
      image:
        'https://images.myloapp.in/NestJsUploads/1727426586338-made-safe.svg',
      html: '<p>Made <span class=subText><b>Safe</b></span> <br/> Certified</p>',
    },
    {
      image:
        'https://images.myloapp.in/NestJsUploads/1727426586341-expert-verified.svg',
      html: '<p>100+ <span class=subText> <b> Expert Verified </b></span> <br/> Products</p>',
    },
  ];
  return (
    <ForYouContainer>
      <div className="promiseImage">
        <img
          src="https://images.myloapp.in/NestJsUploads/1728644959354-mylo-logo-text-only.svg"
          alt="Mylo promis"
        />
        <span className="heading2"> Promise</span>
      </div>

      <div className="innerSection">
        {data?.map((element, index) => {
          return (
            <div key={`forYou_${index}`} className="imageAndText">
              <div className="imageBackground">
                <img src={element?.image} alt="" />
              </div>

              <div
                dangerouslySetInnerHTML={{
                  __html: element.html,
                }}
              />
            </div>
          );
        })}
      </div>
    </ForYouContainer>
  );
}

export default HereForYouSection;
